// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"319":"c2f65bef","693":"83d41e47"}[chunkId] + ".chunk.js";
};